import CompareCardStylesBlock from './CompareCardStylesBlock'
import CompareCardStylesCardBlock from './CompareCardStylesCardBlock'

export { CompareCardStylesBlock, CompareCardStylesCardBlock }
